import {
  Icon,
  ICONS,
  NOTIFICATION_TYPE,
  PLATFORM_THEME_COLORS,
  Popover,
  showNotification,
} from '@thinknet-gmbh/platform-common-ui';
import { PLATFORM_PERMISSIONS, VacancyPatternStatusesEnum } from '@thinknet-gmbh/platform-common';

import { ITableRowPopoverProps } from 'src/pages/vacancies/vacancies.interfaces';
import { VACANCIES_MODALS, VACANCIES_PAGES } from 'src/pages/vacancies/vacancies.constants';

import { useUserCanManageDocument } from 'src/hooks/user-can-manage-document.hook';

const VacanciesTableRowPopover = ({ record, t, handleModals, navigate }: ITableRowPopoverProps) => {
  const { canDelete, canEdit } = useUserCanManageDocument({
    createdBy: record.createdBy,
    platformPermission: PLATFORM_PERMISSIONS.vacanciesManagement,
  });
  const isPublished = record.status === VacancyPatternStatusesEnum.PUBLISHED;
  const isClosed = record.status === VacancyPatternStatusesEnum.CLOSED;

  const handlePublishing = () => {
    if (!isPublished) {
      return handleModals(VACANCIES_MODALS.publishVacancy, {
        ...record,
        status: VacancyPatternStatusesEnum.PUBLISHED,
      });
    }
    navigator.clipboard.writeText(
      `${window.location.href}/${VACANCIES_PAGES.applicantRequestForm}&${record._id}`
    );
    showNotification({
      type: NOTIFICATION_TYPE.success,
      message: t('vacancies:notifications.copyLink'),
    });
  };

  return (
    <Popover
      elements={[
        {
          label: t('employee:labels.viewDetails'),
          icon: ICONS.foodMenu,
          key: ICONS.foodMenu,
          handler: () => navigate(record._id),
        },
        ...(canEdit
          ? [
              {
                label: isPublished
                  ? t('vacancies:buttons.copyLink')
                  : t('vacancies:labels.publishVacancy'),
                icon: isPublished ? ICONS.copy : ICONS.send,
                key: ICONS.send,
                handler: handlePublishing,
              },
              ...(!isClosed
                ? [
                    {
                      label: t('vacancies:labels.closeVacancy'),
                      icon: ICONS.xCircleRegular,
                      key: ICONS.xCircleRegular,
                      handler: () =>
                        handleModals(VACANCIES_MODALS.closeVacancy, {
                          ...record,
                          status: VacancyPatternStatusesEnum.CLOSED,
                        }),
                    },
                  ]
                : []),
            ]
          : []),
        ...(canDelete
          ? [
              {
                label: t('vacancies:deleteVacancy.title'),
                icon: ICONS.trash,
                key: ICONS.trash,
                color: PLATFORM_THEME_COLORS.tone.red,
                handler: () => handleModals(VACANCIES_MODALS.deleteVacancy, record),
              },
            ]
          : []),
      ]}
    >
      <Icon
        icon={ICONS.dotsVerticalRounded}
        size={22}
        color={PLATFORM_THEME_COLORS.primary.grey}
        rightMargin={false}
      />
    </Popover>
  );
};

export default VacanciesTableRowPopover;
